var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOther(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 73.985,
    height: 73.985,
    viewBox: "0 0 73.985 73.985",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_62894",
    "data-name": "Group 62894",
    transform: "translate(-116.84 -562)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45130",
    "data-name": "Path 45130",
    d: "M1891.729-1666.527v7.848l19.9-14.154,2.943,2.8-8.408,6.867v8.128l19.9-14.995,19.619,14.995v-8.128l-9.389-6.867,4.064-2.8,20.04,14.154v-7.848l-20.04-14.294-9.67,7.287-4.625-3.924-5.465,3.924-8.969-7.287Z",
    transform: "translate(-1772 2262)",
    fill: "#90d8ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45131",
    "data-name": "Path 45131",
    d: "M1908.9-1633.693v-6.468h-18.541v12.613H1961.4v-12.613h-18.649v6.468Z",
    transform: "translate(-1772 2262)",
    fill: "#90d8ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45132",
    "data-name": "Path 45132",
    d: "M1890.712-1685.894h37.066l-1.078-4.561-2.736-2.654-3.483-1.576h-3.649l-3.234-1.493-2.571-1.741-5.224-.663-1.741.663-3.814,3.234-2.239,1.576s-3.483,1-3.732,1a36.445,36.445,0,0,0-3.234,2.4Z",
    transform: "translate(-1772 2262)",
    fill: "#90d8ca"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3232",
    "data-name": "Ellipse 3232",
    cx: 6,
    cy: 6.5,
    rx: 6,
    ry: 6.5,
    transform: "translate(176 564)",
    fill: "#90d8ca"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_62893",
    "data-name": "Group 62893",
    transform: "translate(116.84 562)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45125",
    "data-name": "Path 45125",
    d: "M400.67,17.34a8.67,8.67,0,1,1,8.67-8.67A8.68,8.68,0,0,1,400.67,17.34Zm0-14.45a5.78,5.78,0,1,0,5.78,5.78A5.787,5.787,0,0,0,400.67,2.89Zm0,0",
    transform: "translate(-335.355)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45126",
    "data-name": "Path 45126",
    d: "M38.694,15.952H1.445A1.445,1.445,0,0,1,0,14.507a8.906,8.906,0,0,1,9.164-8.9A11.7,11.7,0,0,1,27.98,4.018a9.847,9.847,0,0,1,12.213,9.55,10.028,10.028,0,0,1-.063,1.1,1.445,1.445,0,0,1-1.436,1.285ZM3.065,13.062H37.284A6.955,6.955,0,0,0,27.96,7.043a1.445,1.445,0,0,1-1.667-.507A8.811,8.811,0,0,0,11.268,7.776a1.446,1.446,0,0,1-1.5.785,6,6,0,0,0-6.7,4.5Zm0,0",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45127",
    "data-name": "Path 45127",
    d: "M438.943,451.495a1.41,1.41,0,0,1-.282-.029,1.317,1.317,0,0,1-.27-.081,1.462,1.462,0,0,1-.249-.133,1.515,1.515,0,0,1-.22-.181,1.417,1.417,0,0,1-.181-.22,1.459,1.459,0,0,1-.133-.248,1.506,1.506,0,0,1-.082-.27,1.412,1.412,0,0,1-.028-.283,1.4,1.4,0,0,1,.028-.282,1.448,1.448,0,0,1,.082-.27,1.434,1.434,0,0,1,.133-.25,1.372,1.372,0,0,1,.18-.22,1.4,1.4,0,0,1,.22-.18,1.514,1.514,0,0,1,.25-.133,1.436,1.436,0,0,1,.835-.082,1.452,1.452,0,0,1,.27.082,1.534,1.534,0,0,1,.25.133,1.454,1.454,0,0,1,.22.18,1.369,1.369,0,0,1,.179.22,1.4,1.4,0,0,1,.133.25,1.462,1.462,0,0,1,.082.27,1.437,1.437,0,0,1,.029.282,1.455,1.455,0,0,1-.029.283,1.506,1.506,0,0,1-.082.27,1.421,1.421,0,0,1-.133.248,1.376,1.376,0,0,1-.179.22,1.613,1.613,0,0,1-.22.181,1.536,1.536,0,0,1-.25.133,1.332,1.332,0,0,1-.27.081A1.41,1.41,0,0,1,438.943,451.495Zm0,0",
    transform: "translate(-374.28 -383.78)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45128",
    "data-name": "Path 45128",
    d: "M72.54,163.564H69.863V147.469l.433.318a1.445,1.445,0,0,0,2.3-1.164V138.71a1.446,1.446,0,0,0-.59-1.165L52.245,123.028a1.447,1.447,0,0,0-1.711,0l-8.683,6.378-4-2.941a1.445,1.445,0,0,0-1.711,0l-4,2.941-8.683-6.378a1.446,1.446,0,0,0-1.711,0L1.978,137.546a1.445,1.445,0,0,0-.589,1.164v7.913a1.445,1.445,0,0,0,2.3,1.165l.434-.318v16.095H1.445A1.445,1.445,0,0,0,0,165.009v12.542A1.445,1.445,0,0,0,1.445,179h71.1a1.445,1.445,0,0,0,1.445-1.445V165.009a1.445,1.445,0,0,0-1.445-1.445Zm-5.567-18.217v18.217H55.466V150.906l.434.318.022.016.007,0,.016.011.008.006.014.009.01.006.015.01.008,0,.016.01.007,0,.02.011,0,0,.05.027h0l.021.011.006,0,.02.009.005,0,.021.01,0,0a1.446,1.446,0,0,0,1.053.041h0l.073-.028.007,0,.014-.006.008,0,.011-.005.011-.005.01,0,.013-.006.008,0,.021-.01a1.445,1.445,0,0,0,.793-1.289v-7.913a1.445,1.445,0,0,0-.589-1.164l-7.932-5.826L51.39,133.9Zm-26.7,24.488H33.716v-8.62h6.552Zm1.445-11.51H32.271a1.446,1.446,0,0,0-1.445,1.445v10.065H21.409V148.783l15.583-11.447,15.583,11.447v21.051H43.159V159.77a1.446,1.446,0,0,0-1.445-1.445Zm9.676-32.339,18.317,13.456v4.327L52.245,130.941a1.446,1.446,0,0,0-1.588-.081c-.042.025-.083.052-.122.081l-3.3,2.422L44.293,131.2Zm-14.4,3.437,18.317,13.456v4.327l-.433-.318L37.848,134.378a1.386,1.386,0,0,0-.122-.081,1.45,1.45,0,0,0-1.589.081L19.109,146.887l-.433.318v-4.327ZM4.278,139.442,22.6,125.986l7.1,5.213-2.945,2.164-3.3-2.422a1.444,1.444,0,0,0-1.711,0L4.278,143.768Zm2.734,5.9L22.6,133.9l1.711,1.258-7.932,5.826-.017.012a1.444,1.444,0,0,0-.553.918c0,.014,0,.028-.006.042l-.005.042a1.458,1.458,0,0,0-.008.15v7.913a1.445,1.445,0,0,0,.793,1.289l.023.011a1.448,1.448,0,0,0,1.486-.136l.433-.318v12.658H7.013Zm11.507,21.107v3.381H2.89v-3.381ZM71.1,176.106H2.89v-3.381H58.812a1.445,1.445,0,1,0,0-2.89H55.466v-3.381H71.1Zm0,0",
    transform: "translate(0 -105.01)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45129",
    "data-name": "Path 45129",
    d: "M218.98,273.932a6.253,6.253,0,1,1,6.253-6.253A6.26,6.26,0,0,1,218.98,273.932Zm0-9.616a3.363,3.363,0,1,0,3.363,3.363A3.367,3.367,0,0,0,218.98,264.316Zm0,0",
    transform: "translate(-181.987 -223.649)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOther);
export default __webpack_public_path__ + "static/media/other.1f80dbc732dd8d24d5e182b68b0f4330.svg";
export { ForwardRef as ReactComponent };